// Kill switch for the call pill. On unless the build sets
// VITE_REACT_APP_CALL_PILL=off, in which case the old inbound-call toast
// comes back (LiveNotificationHandler checks this too).
export const isCallPillEnabled = () => {
    try {
        return String(import.meta.env?.VITE_REACT_APP_CALL_PILL ?? '').toLowerCase() !== 'off';
    } catch {
        return true;
    }
};

// Kill switch for click-to-call (CU-869fm5hj1): VITE_REACT_APP_OUTBOUND_CALLS=off
// hides every Call button and pill control whatever the backend says.
export const isOutboundEnabled = () => {
    try {
        return String(import.meta.env?.VITE_REACT_APP_OUTBOUND_CALLS ?? '').toLowerCase() !== 'off';
    } catch {
        return true;
    }
};

// Window event fired for "Log outcome" and "Call back". It is cancelable: a
// screen that handles the action itself (the outbound calling work in
// CU-869fm5hj1) calls preventDefault(), otherwise the pill falls back to Call
// Logs filtered to the caller's number.
export const CALL_PILL_ACTION_EVENT = 'call-pill-action';
